import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button, { CancelButton, ConfirmButton } from 'components/ui/Button';
import { StyledButtonWrapper } from './UpdateVoucherCTA.styles';
import { useVoucherEditSettings } from 'pages/VoucherDetails/useVoucherEditSettings';

const UpdateVoucherCTA = ({ onCancelClick, onEditClick, isEditMode, isConfirmEnabled, hasVoucherExpired }) => {
  const editSettings = useVoucherEditSettings();

  if (!editSettings.form.isVoucherEditable) {
    return <></>;
  }

  return (
    <>
      {!isEditMode && (
        <StyledButtonWrapper>
          <Button type="button" data-cy="edit" onClick={onEditClick} disabled={hasVoucherExpired}>
            <FormattedMessage id="vouchers.edit" />
          </Button>
        </StyledButtonWrapper>
      )}
      {isEditMode && (
        <>
          <StyledButtonWrapper>
            <CancelButton type="button" data-cy="cancel" onClick={onCancelClick}>
              <FormattedMessage id="vouchers.cancel" />
            </CancelButton>
          </StyledButtonWrapper>
          <StyledButtonWrapper>
            <ConfirmButton type="submit" data-cy="submit" disabled={!isConfirmEnabled}>
              <FormattedMessage id="vouchers.confirm" />
            </ConfirmButton>
          </StyledButtonWrapper>
        </>
      )}
    </>
  );
};

UpdateVoucherCTA.propTypes = {
  onEditClick: PropTypes.func.isRequired,
  onCancelClick: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
  isConfirmEnabled: PropTypes.bool,
  hasVoucherExpired: PropTypes.bool
};

export default UpdateVoucherCTA;
